export default function H3(props) {
  return (
    <h3 className={`text-xl font-semibold tracking-tight text-gray-900 ${props.className || ''}`}>
      {props.children}
    </h3>
  )
}
